import React from "react";
import "./about.css";
import SocialContact from "../../common/social-contact/index";
function About() {
  // Function will execute on click of button
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch("EFE-ROY.pdf").then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "EFE-ROY-CV.pdf";
        alink.click();
      });
    });
  };


  return (
    <div className="about">
      <div className="about-top">
        <div className="about-info">
          {/* Dedicated, */}
          <span className="info-name">Dakara Efe Roy</span>
          {/* <br /> <span className="info-name">Dakara Efe Roy</span>. */}
          <br /> <em>Software Developer</em>
        </div>
        <div className="about-photo">
          <img
            src={require("../../../assets/coding1.png")}
            className="picture"
          />
        </div>
      </div>
      {/* <SocialContact /> */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <button
          style={{
            padding: "7px 15px",
            borderRadius: "10px",
            border: "none",
            fontWeight: "900",
            fontSize: "20px",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset",
          }}
          onClick={onButtonClick}
        >
          Download CV
        </button>
      </div>

    </div>
  );
}

export default About;